import { Button } from '../../design-system/primitives/index.js'
import { GUEST_COPY } from '../../config/homeCopy.js'

export default function GuestKitchenStrip({
  status = 'idle',
  onSave,
  onRetry,
  saveEnabled = true,
  setup = false,
}) {
  const className = [
    'guest-strip',
    status === 'offline' ? 'guest-strip--offline' : '',
    status === 'error' ? 'guest-strip--error' : '',
  ].filter(Boolean).join(' ')

  if (status === 'offline') {
    return (
      <aside className={className} role="status">
        <div className="guest-strip__content">
          <i className="fas fa-wifi" aria-hidden="true" />
          <span>{GUEST_COPY.offline}</span>
        </div>
        {saveEnabled ? (
          <span className="guest-strip__action-target">
            <Button variant="secondary" disabled>Save my kitchen</Button>
          </span>
        ) : null}
      </aside>
    )
  }

  if (status === 'error') {
    return (
      <aside className={className} role="alert">
        <div className="guest-strip__content">
          <i className="fas fa-exclamation-circle" aria-hidden="true" />
          <span>{GUEST_COPY.saveError}</span>
        </div>
        <div className="guest-strip__actions">
          <span className="guest-strip__action-target">
            <Button variant="secondary" onClick={onRetry}>Retry</Button>
          </span>
          {saveEnabled ? (
            <span className="guest-strip__action-target">
              <Button variant="secondary" onClick={onSave}>
                Save my kitchen
              </Button>
            </span>
          ) : null}
        </div>
      </aside>
    )
  }

  return (
    <aside className={className} role="status">
      <div className="guest-strip__content">
        <span className="guest-strip__badge">YOUR KITCHEN</span>
        <span>{setup ? GUEST_COPY.setup : GUEST_COPY.strip}</span>
      </div>
      {saveEnabled ? (
        <span className="guest-strip__action-target">
          <Button variant="secondary" onClick={onSave}>
            Save my kitchen
          </Button>
        </span>
      ) : null}
    </aside>
  )
}
